(() => {
  if (window.__exHomeRailsScriptReady) return;
  window.__exHomeRailsScriptReady = true;
  function initRail(section) {
    if (section.dataset.exReady === 'true') return;
    section.dataset.exReady = 'true';
    const viewport = section.querySelector('.ex-rail__viewport');
    const track = section.querySelector('.ex-rail__track');
    const previous = section.querySelector('.ex-rail__prev');
    const next = section.querySelector('.ex-rail__next');
    const progress = section.querySelector('.ex-rail__progress i');
    const count = section.querySelector('.ex-rail__count');
    if (!viewport || !track || !previous || !next || !progress || !count) return;
    let dragging = false;
    let moved = false;
    let originX = 0;
    let originScroll = 0;
    let lastManual = 0;
    const maxScroll = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const step = () => Math.max(160, viewport.clientWidth * .8);
    const update = () => {
      const max = maxScroll();
      const fraction = max ? viewport.scrollLeft / max : 0;
      const width = max ? Math.max(16, viewport.clientWidth / viewport.scrollWidth * 100) : 100;
      progress.style.width = `${width}%`;
      progress.style.transform = `translateX(${fraction * (140 - 140 * width / 100)}px)`;
      previous.disabled = viewport.scrollLeft < 3;
      next.disabled = viewport.scrollLeft >= max - 3;
      const pages = Math.max(1, Math.ceil(viewport.scrollWidth / viewport.clientWidth));
      const page = Math.min(pages, Math.max(1, Math.round(viewport.scrollLeft / viewport.clientWidth) + 1));
      count.textContent = `${String(page).padStart(2, '0')} / ${String(pages).padStart(2, '0')}`;
    };
    previous.addEventListener('click', () => { lastManual = Date.now(); viewport.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', () => { lastManual = Date.now(); viewport.scrollBy({ left: step(), behavior: 'smooth' }); });
    viewport.addEventListener('scroll', update, { passive: true });
    viewport.addEventListener('dragstart', event => event.preventDefault());
    viewport.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      lastManual = Date.now();
      viewport.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * step(), behavior: 'smooth' });
    });
    viewport.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragging = true;
      moved = false;
      originX = event.clientX;
      originScroll = viewport.scrollLeft;
      lastManual = Date.now();
    });
    viewport.addEventListener('pointermove', event => {
      if (!dragging) return;
      const distance = event.clientX - originX;
      if (Math.abs(distance) > 5) {
        moved = true;
        viewport.classList.add('is-dragging');
        viewport.scrollLeft = originScroll - distance;
      }
    });
    const stopDrag = () => {
      dragging = false;
      viewport.classList.remove('is-dragging');
      window.setTimeout(() => { moved = false; }, 50);
    };
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(name => viewport.addEventListener(name, stopDrag));
    viewport.addEventListener('click', event => { if (moved) { event.preventDefault(); event.stopPropagation(); } }, true);
    window.addEventListener('resize', update, { passive: true });
    requestAnimationFrame(update);
    if (!section.hasAttribute('data-ex-autoplay')) return;
    const toggle = section.querySelector('.ex-rail__autoplay');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reducedMotion.matches;
    let hovered = false;
    let focused = false;
    const updateToggle = () => {
      toggle.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
      toggle.setAttribute('aria-pressed', String(paused));
    };
    updateToggle();
    toggle.addEventListener('click', () => { paused = !paused; updateToggle(); });
    section.addEventListener('mouseenter', () => { hovered = true; });
    section.addEventListener('mouseleave', () => { hovered = false; });
    section.addEventListener('focusin', () => { focused = true; });
    section.addEventListener('focusout', event => { if (!section.contains(event.relatedTarget)) focused = false; });
    section.addEventListener('pointerdown', () => { lastManual = Date.now(); });
    const timer = window.setInterval(() => {
      if (!document.contains(section)) { window.clearInterval(timer); return; }
      if (paused || hovered || focused || dragging || document.hidden || Date.now() - lastManual < 3000) return;
      const max = maxScroll();
      const first = track.firstElementChild;
      if (max < 4 || !first) return;
      const distance = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
      viewport.scrollTo({ left: viewport.scrollLeft >= max - 3 ? 0 : Math.min(max, viewport.scrollLeft + distance), behavior: 'smooth' });
    }, 2000);
  }
  function init(root = document) {
    if (root.matches?.('[data-ex-rail]')) initRail(root);
    root.querySelectorAll('[data-ex-rail]').forEach(initRail);
    const addForms = root.matches?.('.ex-card__form') ? [root] : root.querySelectorAll('.ex-card__form');
    addForms.forEach(form => {
      if (form.dataset.exCartReady === 'true') return;
      form.dataset.exCartReady = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (form.dataset.exAdding === 'true') return;
        const button = form.querySelector('[type="submit"]');
        const status = form.querySelector('[data-ex-cart-status]') || document.createElement('span');
        status.dataset.exCartStatus = '';
        status.setAttribute('role', 'status');
        status.className = 'visually-hidden';
        if (!status.parentElement) form.appendChild(status);
        const addUrl = new URL(form.action, window.location.href);
        addUrl.pathname = addUrl.pathname.replace(/\/cart\/add(?:\.js)?$/, '/cart/add.js');
        form.dataset.exAdding = 'true';
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        }
        status.textContent = '';
        try {
          const response = await fetch(addUrl.toString(), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Toevoegen mislukt. Probeer opnieuw.');
          status.textContent = 'Toegevoegd aan winkelwagen';
          const cartTrigger = [...document.querySelectorAll('[data-cart-sidebar]')]
            .find(element => element.getClientRects().length);
          if (cartTrigger) cartTrigger.click();
        } catch (error) {
          status.textContent = error.message || 'Toevoegen mislukt. Probeer opnieuw.';
        } finally {
          form.dataset.exAdding = 'false';
          if (button) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        }
      }, true);
    });
    const wishlistButtons = root.matches?.('.ex-card [data-wishlist]') ? [root] : root.querySelectorAll('.ex-card [data-wishlist]');
    wishlistButtons.forEach(button => {
      if (button.dataset.exWishlistReady === 'true') return;
      button.dataset.exWishlistReady = 'true';
      const syncWishlistState = () => {
        const added = button.classList.contains('wishlist-added');
        const label = added ? button.dataset.wishlistAddedLabel : button.dataset.wishlistAddLabel;
        const productTitle = button.closest('.ex-card')?.querySelector('.ex-card__title')?.textContent?.trim();
        button.setAttribute('aria-pressed', String(added));
        button.setAttribute('aria-label', productTitle ? `${label}: ${productTitle}` : label);
        button.title = label;
      };
      new MutationObserver(syncWishlistState).observe(button, { attributes: true, attributeFilter: ['class'] });
      syncWishlistState();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
